import { ITileInternalConfig } from '../../../redux/models/tiles.model';

export const internalTilesConfig: { [tileName: string]: ITileInternalConfig } = {
  news: {
    title: $localize`:@@amadeus-direct.homepageLatestNews:Latest news`,
    linkPath: '/news',
    linkText: $localize`:@@amadeus-direct.homepageAllNews:All news`
  },
  dashboard: {
    title: $localize`:@@amadeus-direct.dashboardPersonalPerformance:Performance`,
    linkPath: '/dashboard',
    linkText: $localize`:@@amadeus-direct.dashboardMainHeading:Dashboard`
  },
  taskmanager: {
    title: $localize`:@@amadeus-direct.homepageMyTasks:My tasks`,
    linkPath: '/tasks',
    linkText: $localize`:@@amadeus-direct.taskAllTasks:All tasks`
  },
  book: {
    rawTitle: 'TripMaker - Beta'
  },
  sso: {
    title: $localize`:@@amadeus-direct.relatedSites:Related sites`
  },
  loyalty: {
    custom: true
  },
  banner: {
    custom: true
  }
};
